import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ModalWindow from '../ModalWindow/ModalWindow';
import {selectShowIsolationismModal} from '../../../redux/reducers/privateStateReducer/selectors';
import {hideIsolationismModal, isolationismInterceptInitiative, showToast, withToastIcon} from '../../../redux/actions';
import './IsolationismModal.css';
import ModalButton from "../ModalWindow/ModalButton/ModalButton";
import {SUCCESS_COLOR} from "../../../styles/constants";
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";
import {selectGameResults} from "../../../redux/reducers/sharedStateReducer/selectors";
import {TOAST_ICONS} from "../../../constants/toast";

const IsolationismModal = () => {
  const dispatch = useDispatch();
  const modalShown = useSelector(selectShowIsolationismModal);
  const gameResults = useSelector(selectGameResults);

  if (!modalShown || gameResults) {
    return null;
  }

  const handleIntercept = () => {
    dispatch(isolationismInterceptInitiative());
    dispatch(withToastIcon(showToast('Вы перехватили инициативу!\n\nВы будете ходить первым в фазе Войны.', 'success', 5000, true), TOAST_ICONS.INITIATIVE));
    REGISTRY_SINGLETON.getSoundManager().playInitiativeInterception();

    dispatch(hideIsolationismModal());
  };

  const handleClose = () => {
    dispatch(hideIsolationismModal());
  };

  return (
    <ModalWindow handleClose={handleClose}>
      <div className="isolationism-modal-header">
        <h2>
          При покупке Изоляционизма
        </h2>
        <h2>
          можно перехватить инициативу,
        </h2>
        <h2>
          не тратя
          <img
            className="isolationism-modal_action-icon"
            src={`/img/icons/action.png`}
            alt={'Действие'}
            title={'Действие в Фазе Строительства'}
          />
          .
        </h2>
      </div>
      <div className="isolationism-modal-footer">
        <ModalButton
          onClick={handleIntercept}
          text={'Перехватить'}
          style={{
            backgroundColor: SUCCESS_COLOR,
          }}
        >
          <h2>
            Перехватить
          </h2>
          <img
            className={'isolationism-modal_initiative-icon'}
            src={`/img/icons/initiative white.png`}
            alt={'close'}
          />
        </ModalButton>
        <ModalButton
          onClick={handleClose}
          text={'Отказаться'}
        />
      </div>
    </ModalWindow>
  );
};

export default IsolationismModal;
